var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"actual-calculation"},[_c('div',{staticClass:"actual-calculation__content"},[_c(_setup.iconComponent,{tag:"component",staticClass:"actual-calculation__icon"}),(_vm.label)?_c('span',{staticClass:"actual-calculation__label"},[_vm._v(_vm._s(_setup.typeLabel))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }